import { Box } from "@mui/material";
import { ListViewLoader } from "./ListViewLoader";

export const InterfaceListLoader = () => {
  return (
    <Box display="flex" flexDirection="column" paddingBottom="80px" gap="16px">
      <ListViewLoader tableSize="small" type="deployment" paddingBottom={false} />
      <ListViewLoader tableSize="small" type="questionnaire" paddingBottom={false} />
      <ListViewLoader tableSize="small" type="deployment" paddingBottom={false} />
    </Box>
  );
};
